export default __webpack_public_path__ + "static/media/Collage-for-home-screen-1.36240d75.jpg";